import $ from "jquery";
import apiURL from "../config/environment";
import {orderAdminRowsBy} from "../utils";

export const setAdminData = ({orderBy, order, setRows, endpoint, navigate, setSchedules}) => {
    const token = JSON.parse(localStorage.getItem("userInfo"))?.token;
    $.ajax({
        method: "GET",
        url: apiURL + `admin/sites/${endpoint}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
        .done((data) => {
            orderAdminRowsBy(data, orderBy, order, setRows);
        })
        .fail((res) => {
            if (res.status === 401) {
                localStorage.removeItem("userInfo");
                navigate("/login");
            }
        });

    $.ajax({
        method: "GET",
        url: apiURL + "admin/schedules?includeConstantSchedules=true",
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
        .done((data) => {
            setSchedules(data)
        })
        .fail((res) => {
            if (res.status === 401) {
                localStorage.removeItem("userInfo");
                navigate("/login");
            } else {
                console.error("Error fetching schedule:", res);
            }
        });

}
